<div class="container-spinner" *ngIf="isLoading | async">
    <mat-spinner class="mat-spinner-color"></mat-spinner>
    <div class="text-spinner">Procesando...</div>
</div>
